import axios from 'axios';

export const getShipperHQOrderDetails = (storeGuid, orderNumber) => {
  return axios
    .get(`shipperHQ?orderNumber=${orderNumber}&storeGuid=${storeGuid}`)
    .then((response) => response.data)
    .catch((e) => {
      throw new Error(e);
    });
};
